import { useTheme } from "@/context/ThemeContext";
import { useBranding, brandingUrl } from "@/lib/branding";

/** Brand logo. Shows the company's own logo when the Company Admin has uploaded one
 *  (Settings → Company branding); otherwise the PRIZM logo. Swaps light/dark with the theme. */
export default function BrandLogo({ className = "", alt, testid = "brand-logo" }) {
  const { theme } = useTheme() || {};
  const b = useBranding();
  const dark = theme === "dark";
  const custom = b?.logo_light_url
    ? brandingUrl(dark ? (b.logo_dark_url || b.logo_light_url) : b.logo_light_url)
    : null;
  const src = custom || (dark ? "/prizm-logo-dark.png" : "/prizm-logo-light.png");
  const label = alt || (custom ? "Company logo" : "Prizm — AI Insights. Workforce Clarity. Better Decisions.");
  return <img src={src} alt={label} className={`${className} ${custom ? "object-contain" : ""}`} data-testid={testid} data-custom-logo={custom ? "1" : "0"} />;
}
